var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu24Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/menu_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/menu_24px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "holder",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_menu",
    transform: "translate(3.000000, 5.000000)",
    fill: "#0C0C0C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,14 L17,14 C17.5522847,14 18,13.5522847 18,13 C18,12.4477153 17.5522847,12 17,12 L1,12 C0.44771525,12 -4.54747351e-13,12.4477153 -4.54747351e-13,13 C-4.54747351e-13,13.5522847 0.44771525,14 1,14 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,8 L17,8 C17.5522847,8 18,7.55228475 18,7 C18,6.44771525 17.5522847,6 17,6 L1,6 C0.44771525,6 -4.54747351e-13,6.44771525 -4.54747351e-13,7 C-4.54747351e-13,7.55228475 0.44771525,8 1,8 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2 L17,2 C17.5522847,2 18,1.55228475 18,1 C18,0.44771525 17.5522847,0 17,0 L1,0 C0.44771525,0 -4.54747351e-13,0.44771525 -4.54747351e-13,1 C-4.54747351e-13,1.55228475 0.44771525,2 1,2 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu24Px);
export default __webpack_public_path__ + "static/media/menu_24px.351f2e39ca45f085da180617f2fbb674.svg";
export { ForwardRef as ReactComponent };